import React from 'react'

export const themeDefaults = {
     lbg: "#dae1ed",  // lightest-blue
     bg: "#b4cbef",  // very-light-blue
     ebg: "#efb3ca",  // very-light-red
     abg: "#b3efca",  // very-light-green
     fg: "#82abed",  // solid sky
     efg: "#ed82ab",     // reddish
     sfg: "#214682",  // dark blue
     ptxt: "#ffa0a0",  // pink
     stxt: "#214682",  // dark blue
     ttxt: "#5274ea",  // transparent blue
     nselbg: "#fff4",  // non-selectable background, transparent white
     nselbor: "rgb(204, 204, 204)",    // non-selectable border color, light grey
     green: "#7be800",
     yellow: "#edc482"
 }


